var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.$route.path + _vm.$route.query.t,staticStyle:{"background-color":"white"}})
}
var staticRenderFns = []

export { render, staticRenderFns }